import axios from 'axios';

async function ObtenerPreguntasFrecuentes( prmFiltro: string = "" ) {
 
    // El valor de prmFiltro puede ser:
    // "" : Trae todas las preguntas frecuentes
    // "activas" : Trae las preguntas frecuentes activas (no dadas de baja ni deshabilitadas)
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_preguntasfrecuentes"
    
 
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "filtro": prmFiltro
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerPreguntasFrecuentes;